import Model from "./base/model";

class SimulationKgValue extends Model {
  resourceName() {
    return "simulation_kg_values";
  }

  fields() {
    return {
      simulation_kg_range_id: "",
      simulation_destination_id: "",
      value: "",

      simulation_kg_range: {jsonApi: "hasOne", type: "simulation_kg_ranges"},
      simulation_destination: {jsonApi: "hasOne", type: "simulation_destinations"},

    };
  }
}

export default new SimulationKgValue();
